import {Component, Input} from '@angular/core';
import {DocumentMaster} from '../models/document-master';
import {Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as actions from '../actions/document';
import {DocumentInfo} from '../models/document-info';
import {Observable} from 'rxjs/Observable';
@Component({
  selector: 'document-attach',
  template: `
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div>
                  <document-attach-form 
                    [docInfo]="currentDoc$ | async" 
                    (saveMetaData)="attach($event)"
                    (uploadFile)="upload($event)"
                    (resetFileUpload)="reset($event)"
                    [progress]="progress"
                    [uploading]="uploading$ | async"></document-attach-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class DocumentAttachDirectiveComponent {

  @Input() progress: number;

  public currentDoc$: Observable<DocumentMaster>;
  public uploading$: Observable<boolean>;

  constructor(private store: Store<fromRoot.State>) {
    this.currentDoc$ = this.store.select(fromRoot.getCurrentFile);
    this.uploading$ = this.store.select(fromRoot.getDocumentUploading);
  }


  attach(data: DocumentMaster) {
    this.store.dispatch(new actions.AttachMetadataToFileAction(data));
  }

  upload(file: DocumentInfo) {
    this.store.dispatch(new actions.UploadFileAction(file));
  }

  reset() {
    this.store.dispatch(new actions.ResetDocumentUploadAction());
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/containers/document-attach.ts